// Seat Map Configuration for Teatro Sant'Anna
// Total: 197 seats

export const TEATRO_SANT_ANNA_CONFIG = {
  venueId: "teatro-sant-anna",
  venueName: "Teatro Sant'Anna",
  totalSeats: 197,
  rows: [
    { row: 1, seats: 14, startNumber: 1 },
    { row: 2, seats: 14, startNumber: 1 },
    { row: 3, seats: 14, startNumber: 1 },
    { row: 4, seats: 14, startNumber: 1 },
    { row: 5, seats: 14, startNumber: 1 },
    { row: 6, seats: 14, startNumber: 1 },
    { row: 7, seats: 14, startNumber: 1 },
    { row: 8, seats: 14, startNumber: 1 },
    { row: 9, seats: 15, startNumber: 1 },
    { row: 10, seats: 15, startNumber: 1 },
    { row: 11, seats: 13, startNumber: 1 },
    { row: 12, seats: 14, startNumber: 1 },
    { row: 13, seats: 14, startNumber: 1 },
    { row: 14, seats: 14, startNumber: 1 },
  ]
};

// Seat Map Configuration for Teatro Torretta Asti
// Total: 192 seats (16 rows x 12 seats, with center aisle)
export const TEATRO_TORRETTA_CONFIG = {
  venueId: "teatro-torretta",
  venueName: "Teatro Torretta",
  totalSeats: 192,
  hasAisle: true,  // Has center aisle
  rows: [
    { row: 1, leftSeats: [1, 2, 3, 4, 5, 6], rightSeats: [7, 8, 9, 10, 11, 12] },
    { row: 2, leftSeats: [13, 14, 15, 16, 17, 18], rightSeats: [19, 20, 21, 22, 23, 24] },
    { row: 3, leftSeats: [25, 26, 27, 28, 29, 30], rightSeats: [31, 32, 33, 34, 35, 36] },
    { row: 4, leftSeats: [37, 38, 39, 40, 41, 42], rightSeats: [43, 44, 45, 46, 47, 48] },
    { row: 5, leftSeats: [49, 50, 51, 52, 53, 54], rightSeats: [55, 56, 57, 58, 59, 60] },
    { row: 6, leftSeats: [61, 62, 63, 64, 65, 66], rightSeats: [67, 68, 69, 70, 71, 72] },
    { row: 7, leftSeats: [73, 74, 75, 76, 77, 78], rightSeats: [79, 80, 81, 82, 83, 84] },
    { row: 8, leftSeats: [85, 86, 87, 88, 89, 90], rightSeats: [91, 92, 93, 94, 95, 96] },
    { row: 9, leftSeats: [97, 98, 99, 100, 101, 102], rightSeats: [103, 104, 105, 106, 107, 108] },
    { row: 10, leftSeats: [109, 110, 111, 112, 113, 114], rightSeats: [115, 116, 117, 118, 119, 120] },
    { row: 11, leftSeats: [121, 122, 123, 124, 125, 126], rightSeats: [127, 128, 129, 130, 131, 132] },
    { row: 12, leftSeats: [133, 134, 135, 136, 137, 138], rightSeats: [139, 140, 141, 142, 143, 144] },
    { row: 13, leftSeats: [145, 146, 147, 148, 149, 150], rightSeats: [151, 152, 153, 154, 155, 156] },
    { row: 14, leftSeats: [157, 158, 159, 160, 161, 162], rightSeats: [163, 164, 165, 166, 167, 168] },
    { row: 15, leftSeats: [169, 170, 171, 172, 173, 174], rightSeats: [175, 176, 177, 178, 179, 180] },
    { row: 16, leftSeats: [181, 182, 183, 184, 185, 186], rightSeats: [187, 188, 189, 190, 191, 192] },
  ]
};

// Get config by venue ID
export const getVenueConfig = (venueId) => {
  switch (venueId) {
    case 'teatro-torretta':
      return TEATRO_TORRETTA_CONFIG;
    case 'teatro-sant-anna':
    default:
      return TEATRO_SANT_ANNA_CONFIG;
  }
};

// Generate all seat IDs for the venue
export const generateAllSeats = (config) => {
  const seats = [];
  config.rows.forEach(rowConfig => {
    for (let i = 0; i < rowConfig.seats; i++) {
      seats.push({
        id: `${rowConfig.row}-${rowConfig.startNumber + i}`,
        row: rowConfig.row,
        seat: rowConfig.startNumber + i,
        label: `Fila ${rowConfig.row}, Posto ${rowConfig.startNumber + i}`
      });
    }
  });
  return seats;
};

// Get row letter (for display purposes)
export const getRowLabel = (rowNumber) => {
  return `Fila ${rowNumber}`;
};

export const ALL_SANT_ANNA_SEATS = generateAllSeats(TEATRO_SANT_ANNA_CONFIG);
